import UserEvent from './UserEvent';

type EventData = {
  isBot: boolean;
};

class CompareRetailersClickEvent extends UserEvent<EventData> {
  collectServerEvents() {
    this.serverEvents.push({
      type: 'compare_retailers_click'
    });
  }
}

export default CompareRetailersClickEvent;
